import Home from './Home.data-manager-edit-dsp.vue'

export default {
  Home
}